import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import { setPreviewImages } from '@src/store/reducers/UIReducer';
import React, { useState } from 'react';
import styled from 'styled-components';

const ImagePreviewContainer = styled.div<{ active: boolean }>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.6);
	display: ${({ active }) => (active ? 'flex' : 'none')};
	justify-content: center;
	align-items: center;
	z-index: 7777;
`;

const Image = styled.img`
	max-width: 90%;
	max-height: 90%;
`;

const CloseIcon = styled.span`
	position: absolute;
	top: 6px;
	right: 8px;
	color: white;
	cursor: pointer;
	z-index: 7777;
`;

const MoveIcon = styled.span`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	color: white;
	font-size: 24px;
	cursor: pointer;
	z-index: 7777;
`;

interface PreviewImageProps {
	imageUrls: string | string[];
}

const PreviewImage: React.FC<PreviewImageProps> = ({ imageUrls }) => {
	const [active, setActive] = useState<boolean>(true);
	const isPreviewImages: any = useAppSelector((state) => state?.UI?.isPreviewImages);
	const [currentIndex, setCurrentIndex] = useState<number>(0);
	const dispatch = useAppDispatch();

	const handleClose = () => {
		dispatch(setPreviewImages([]));
	};

	const handleNext = () => {
		setCurrentIndex((prevIndex) => (prevIndex === imageUrls.length - 1 ? 0 : prevIndex + 1));
	};

	const handlePrev = () => {
		setCurrentIndex((prevIndex) => (prevIndex === 0 ? imageUrls.length - 1 : prevIndex - 1));
	};

	const isMultipleImages = Array.isArray(imageUrls);

	return (
		<ImagePreviewContainer active={isPreviewImages?.length}>
			<CloseIcon onClick={handleClose}>X</CloseIcon>
			{isMultipleImages && (
				<>
					<MoveIcon onClick={handlePrev} style={{ left: 10 }}>
						◄
					</MoveIcon>
					<MoveIcon onClick={handleNext} style={{ right: 10 }}>
						►
					</MoveIcon>
				</>
			)}
			<Image src={isMultipleImages ? imageUrls[currentIndex] : imageUrls} alt="Preview" />
		</ImagePreviewContainer>
	);
};

export default PreviewImage;
